import { createContext, useCallback, useContext, useState } from "react";
import useTranslation from "../../hooks/i18n/useTranslation";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const { t } = useTranslation();
  const [maximizedWidget, setMaximizedWidget] = useState(null);

  const handleMaximizeWidget = useCallback((widgetId) => {
    setMaximizedWidget(prev => prev === widgetId ? null : widgetId);
  }, []);

  const getTranslatedTitle = useCallback((titleKey) => t(titleKey), [t]);

  return (
    <DashboardContext.Provider
      value={{
        maximizedWidget,
        handleMaximizeWidget,
        getTranslatedTitle,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error("useDashboard must be used within a DashboardProvider");
  }
  return context;
};